export const DEFAULT_APPOINTMENT_TYPE = 'initial-consult';

export const LEAD_ID_SIGNUP_URL_PARAMETER = 'leadId';

export const getAppointmentTypeFromURL = () => {
  const appointmentType = new URL(window.location.href).searchParams.get('type');

  if (appointmentType) {
    return appointmentType;
  }

  return DEFAULT_APPOINTMENT_TYPE;
};

export const getCalendarIDFromURL = () => {
  const calendarID = new URL(window.location.href).searchParams.get('calendar');

  if (calendarID) {
    return calendarID;
  }

  return undefined;
};

export const getLeadIDFromURL = () => {
  const leadId = new URL(window.location.href).searchParams.get(LEAD_ID_SIGNUP_URL_PARAMETER);

  if (leadId) {
    return leadId;
  }

  return undefined;
};

export const setLeadIDToURL = (leadID: string) => {
  const url = new URL(window.location.href);

  url.searchParams.set(LEAD_ID_SIGNUP_URL_PARAMETER, leadID);

  window.history.pushState({}, '', url.toString());
};
